import { Injectable, InjectionToken, Provider } from '@angular/core';

import { Observable, Subject, filter, map, noop, take } from 'rxjs';

import { NotificationType } from '../../model';

@Injectable()
export class AccaBoostNotificationSyncService {
    private done = new Subject<NotificationType>();
    readonly done$ = this.done.asObservable();

    markAsDone(type: NotificationType): void {
        this.done.next(type);
    }
}

export const NOTIFICATION_LADDER_VISIBLE = new InjectionToken<Observable<void>>(
    'An observable that fires when the ladder notification animation is done and notification is fully visible',
);

export const NOTIFICATION_LADDER_VISIBLE_PROVIDER: Provider = {
    provide: NOTIFICATION_LADDER_VISIBLE,
    deps: [AccaBoostNotificationSyncService],
    useFactory: (syncService: AccaBoostNotificationSyncService) => create(syncService, NotificationType.Ladder),
};

function create(syncService: AccaBoostNotificationSyncService, notificationType: NotificationType): Observable<void> {
    return syncService.done$.pipe(
        filter((notification) => notification === notificationType),
        take(1),
        map(noop),
    );
}
